import { StockQuant } from "@byteflies/odoo-typescript";
import { VIRT_SCRAP, id, WH_SCRAP, WH_TRASH } from "./erp/odoo/OdooUtils";

export function isScrapped(currentLocations: StockQuant[]) {
	if (currentLocations === undefined || currentLocations.length === 0) {
		return false;
	}

	const scrapped = currentLocations
		.filter((l) => l.quantity > 0)
		.filter((l) =>
			[VIRT_SCRAP, WH_SCRAP, WH_TRASH].includes(id(l.location_id)!),
		);
	if (scrapped.length > 0) {
		return true;
	}
	return false;
}
